import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerGroupExport(groupId: string) {
	logGoogleTagManagerEvent({
		event: 'cogvio.groupExport',
		groupExport: { id: groupId },
	});
}
